import { render, staticRenderFns } from "./wtTransitionButton.vue?vue&type=template&id=2849fb32&scoped=true&"
import script from "./wtTransitionButton.vue?vue&type=script&lang=js&"
export * from "./wtTransitionButton.vue?vue&type=script&lang=js&"
import style0 from "./wtTransitionButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wtTransitionButton.vue?vue&type=style&index=1&id=2849fb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849fb32",
  null
  
)

export default component.exports